// extracted by mini-css-extract-plugin
export default {"root":"FrontPage_root__OWuQJ","introSection":"FrontPage_introSection__YST-s","logo":"FrontPage_logo__tYn1C","title":"FrontPage_title__SAMMf","userName":"FrontPage_userName__8CLEQ"};